import MailThread from './MailThread';

export default MailThread;


// WEBPACK FOOTER //
// /src/components/mailThread/index.js